import { Injectable } from '@angular/core';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import {
  TimbradoDTO,
  TimbradoResponse,
} from '../../models/configuracoes/timbrao.model';

@Injectable({
  providedIn: 'root',
})
export class TimbradoService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: any): Observable<TimbradoResponse> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<TimbradoResponse>(patch);
  }

  getById<T>(url: string): Observable<TimbradoDTO> {
    return this.apiService.read<TimbradoDTO>(url);
  }

  post<T>(url: string, data: TimbradoDTO): Observable<TimbradoDTO> {
    return this.apiService.create<TimbradoDTO>(url, data);
  }

  put<T>(url: string, data: TimbradoDTO): Observable<TimbradoDTO> {
    return this.apiService.update<TimbradoDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }
}
